// 登录指令
export default defineNuxtPlugin((nuxtApp) => {
  const loginStore = useLoginStore()
  nuxtApp.vueApp.directive('login', {
    mounted(el: HTMLElement) {
      el.addEventListener(
        'click',
        (e: MouseEvent) => {
          if (
            !localStorage.getItem('ticket') &&
            !localStorage.getItem('loginInfo')
          ) {
            loginStore.setIsShowLogin(true)
            e.stopImmediatePropagation()
          }
        },
        true
      )
    }
  })
})
